import { getPreparedParams, getPreparedDepartmentExportParams } from './utils'
import { api } from '../../api'

export const productionReportApi = api
  .enhanceEndpoints({
    addTagTypes: ['ReportList'],
  })
  .injectEndpoints({
    endpoints: (builder) => ({
      getReportDepartment: builder.query({
        providesTags: ['ReportList'],
        query: (params) => {
          return {
            url: `/report/department`,
            method: 'GET',
            params: getPreparedParams(params),
          }
        },
        transformResponse: (response) => response?.data || [],
      }),
      exportReportDepartment: builder.mutation({
        query: ({ format = 'xlsx', params }) => {
          return {
            url: `/report/department/export.${format}`,
            method: 'GET',
            params: getPreparedDepartmentExportParams(params),
          }
        },
      }),
    }),
  })

export const {
  useGetReportDepartmentQuery,
  useLazyGetReportDepartmentQuery,
  useExportReportDepartmentMutation,
} = productionReportApi
